import { useState } from "react";
import { useAuth } from "../lib/auth";
import { useNavigate, Navigate } from "react-router-dom";
import { Truck } from "lucide-react";
import { InstallPWA } from "../components/InstallPWA";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) return <Navigate to="/app" replace />;

  async function onSubmit(e) {
    e.preventDefault();
    setErr("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (!res.ok) setErr(res.error);
    else navigate("/app");
  }

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FDFCF8]">
      <div className="relative hidden lg:block">
        <img
          src="https://images.pexels.com/photos/10359129/pexels-photo-10359129.jpeg"
          alt="Logistics fleet at sunset"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-black/70 via-black/40 to-black/70" />
        <div className="relative h-full flex flex-col justify-between p-12 text-white">
          <div className="flex items-center gap-3">
            <img src="/ito-logo.png" alt="ITO" className="w-12 h-12 object-contain" />
            <div>
              <div className="font-headings font-bold leading-tight">INDIAN TRANSPORT</div>
              <div className="font-headings font-bold leading-tight text-[#FF8A65]">ORGANISATION</div>
              <div className="text-[10px] uppercase tracking-widest opacity-70 mt-1">सत्यम् शिवम् सुंदरम्</div>
            </div>
          </div>
          <div>
            <h1 className="font-headings text-4xl lg:text-5xl font-bold leading-tight max-w-md">
              Every truck. Every receipt. Every rupee.
            </h1>
            <p className="text-white/70 mt-4 max-w-md text-sm leading-relaxed">
              A daily operations cockpit — track lorry receipts, issue invoices, and chase
              every overdue rupee without losing a paper trail.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={onSubmit} className="w-full max-w-sm fadeup" data-testid="login-form">
          <div className="mb-8">
            <div className="text-xs uppercase tracking-widest text-[#68665E] mb-2">Sign In</div>
            <h2 className="font-headings text-3xl font-bold text-[#1A1A18]">Welcome back.</h2>
            <p className="text-sm text-[#68665E] mt-2">Use your company credentials to continue.</p>
          </div>

          <label className="input-label">Email</label>
          <input
            className="input-field mb-4"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email-input"
            required
          />

          <label className="input-label">Password</label>
          <input
            className="input-field mb-6"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password-input"
            required
          />

          {err && (
            <div className="badge-error mb-4 w-full justify-center py-2" data-testid="login-error">
              {err}
            </div>
          )}

          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-submit-button">
            {busy ? "Signing in..." : "Sign in"}
          </button>

          <InstallPWA />
        </form>
      </div>
    </div>
  );
}
